import { TenantHome } from "@/components/tenant/TenantHome";

export const TenantIndexPage = () => {
  return <TenantHome />;
};
